import request from '@/utils/request'
import {
    getAllUsersUrl,
    createUserUrl,
    editUsersUrl,
    delUsersUrl,
    sendQiYeEmailUrl
} from '@/utils/urls'

/** 获取用户列表 */
export function getAllUsers() {
    return request({
        url: getAllUsersUrl,
        method: 'get'
    })
}

/** 新增用户 */
export function createUser(data) {
    return request({
        url: createUserUrl,
        method: 'post',
        data
    })
}

/** 编辑用户 */
export function editUsers(data) {
    return request({
        url: editUsersUrl,
        method: 'post',
        data
    })
}

/** 删除用户 */
export function delUsers(data) {
    return request({
        url: delUsersUrl,
        method: 'post',
        data
    })
}

/** 发送邮件 */
export function sendQiYeEmail(data) {
    return request({
        url: sendQiYeEmailUrl,
        method: 'post',
        data
    })
}

/**
 * @param {String} text 需要复制的内容
 * @return {Boolean} 复制成功:true或者复制失败:false  执行完函数后，按ctrl + v试试
 */
function copyText(text, fn) {
    var textValue = document.createElement('textarea');
    textValue.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
    textValue.value = text;
    document.body.appendChild(textValue); //将textarea添加为body子元素
    textValue.select();
    var res = document.execCommand('copy');
    document.body.removeChild(textValue);//移除DOM元素
    fn();
    return res;
}